import withRouter from 'react-router/lib/withRouter';
import { compose } from 'recompose';
import CancelButtonLink from '../../../../common/buttons/cancelButtonLink';

export default compose(
  withRouter,
)(CancelButtonLink);
